import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React, { useContext, useMemo } from "react";
import Spinner from "../../../components/Spinner";
import { useGetDocTypeList } from "../../../shared/hooks/useDocTypesData";
import { useLoadDoctype } from "../../../shared/hooks/useFrappeDoctype";
import { PosContext } from "../../../shared/PosContext";
import OrderCartItem from "./OrderCartItem";
import { useStyles } from "./styles";

function OrderDetailsDialog({ isOpen, toggle, title, selectedCustomer, orderName }) {
    const cartItems = [];
    const classes = useStyles();

    const { getMenuItem, addonsItems } = useContext(PosContext);

    const { data: getCustomerOrders } = useGetDocTypeList({
        doctype: "Table Order",
        filters: [
            ["customer", "=", selectedCustomer],
            ["status", "=", "Invoiced"],
        ],
        sortBy: "creation desc",
        limit: 20,
        fields: ["name", "creation"],
    });

    const { data: getCustomerLastOrder, isLoading } = useLoadDoctype(
        "Table Order",
        orderName || getCustomerOrders?.[0]?.name
    );

    const invoiceData = useMemo(() => {
        return getCustomerLastOrder?.docs?.[0] || {};
    }, [getCustomerLastOrder]);

    const items = invoiceData.entry_items || [];

    let total = 0;

    items.forEach((item) => {
        total += item.qty * item.rate;
    });

    items.forEach((i) => {
        const menuItem = getMenuItem(i.item_code);
        if (menuItem) {
            const itemAddons = [];
            const addonsArray = i.addons ? JSON.parse(i.addons) : [];

            if (addonsArray && addonsArray.length > 0) {
                addonsArray.map((ad) => {
                    itemAddons.push(
                        addonsItems.find((entry) => entry.item_code === ad)
                    );
                });
            }
            cartItems.push({
                item: {
                    ...i,
                    cover: menuItem.cover,
                    standard_rate: menuItem.standard_rate,
                },
                addons: itemAddons,
                qty: i.qty,
                entry_name: menuItem.identifier,
            });
        }
    });
    return (
        <Dialog
            open={isOpen}
            onClose={() => {
                toggle?.();
            }}
        >
            <DialogTitle
                style={{ display: "flex", justifyContent: "space-between" }}
            >
                {title || ""}
                <Button
                    onClick={() => {
                        toggle();
                    }}
                >
                    Close
                </Button>
            </DialogTitle>
            <DialogContent>
                {!isLoading ? (
                    <div className={classes.OrderWidget}>
                        <div className={classes.OrderCartItems}>
                            {cartItems.map((item, idx) => {
                                return (
                                    <OrderCartItem
                                        key={`order-item-${idx}`}
                                        item={item}
                                    />
                                );
                            })}

                            <div className="Pricing__Total">
                                <div>
                                    <span>Total</span>
                                    <span>{total}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <Spinner />
                )}
            </DialogContent>
        </Dialog>
    );
}

export default OrderDetailsDialog;
